import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _VendorPaymentsFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 4.00049C3 2.34363 4.34315 1.00049 6 1.00049H18C19.6569 1.00049 21 2.34363 21 4.00049V12.0005C21 12.5528 20.5523 13.0005 20 13.0005C19.4477 13.0005 19 12.5528 19 12.0005V4.00049C19 3.4482 18.5523 3.00049 18 3.00049H6C5.44771 3.00049 5 3.4482 5 4.00049V18.8589C5 19.7709 6.12089 20.2069 6.73716 19.5346L7.35136 18.8646C8.5055 17.6055 10.4764 17.5627 11.6841 18.7704L13.2071 20.2934C13.5976 20.6839 13.5976 21.3171 13.2071 21.7076C12.8166 22.0981 12.1834 22.0981 11.7929 21.7076L10.2699 20.1846C9.86735 19.7821 9.21038 19.7963 8.82567 20.216L8.21146 20.8861C6.36267 22.9029 3 21.5949 3 18.8589V4.00049Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2889 11.7328C15.554 11.5297 15.8089 11.2843 16.0352 11.0005V12.402C16.0352 14.102 14.2443 15.4789 12.0352 15.4789C9.82601 15.4789 8.03516 14.102 8.03516 12.402V11.0005C8.26205 11.2828 8.51248 11.5288 8.78144 11.7336C9.65687 12.4066 10.8089 12.7866 12.0352 12.7866C13.2614 12.7866 14.4134 12.4066 15.2889 11.7328Z"
        fill={iconColor}
      />
      <Path
        d="M16.0351 8.80049C16.0351 10.3469 14.2439 11.6005 12.0351 11.6005C9.82626 11.6005 8.03506 10.3469 8.03506 8.80049C8.03506 7.25409 9.82626 6.00049 12.0351 6.00049C14.2439 6.00049 16.0351 7.25409 16.0351 8.80049Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const VendorPaymentsFilledIcon = assignWithoutSideEffects(_VendorPaymentsFilledIcon, {
  componentId: 'VendorPaymentsFilledIcon',
});

export default VendorPaymentsFilledIcon;
